export default "__VITE_ASSET__CyO$FDQo__"